import React from 'react';
import { Typography, Button, Tooltip, Link, } from '@one-thd/sui-atomic-components';
import { useConfigService } from '@thd-nucleus/experience-context';
import { Store, Wallet, Clock, InfoFilled } from '@one-thd/sui-icons';
import { PROXTRA_PROGRAM_DETAILS, MANAGE_ASSIGN_PRO_ALLOWANCE_PATH, } from '../../../constants/links';
import { track } from '../../../utils/analytics';
import { PRO_GET_STARTED } from '../../../constants/analytics';
import { getCheckoutAccessTypeLabel } from '../../../constants/general';
var advantages = [
    {
        icon: function () { return React.createElement(Wallet, null); },
        title: 'Keep Jobs on Budget',
        description: function () { return (React.createElement(Typography, null, "Set up spending limits and monitor all purchase history when someone else shops for you.")); },
    },
    {
        icon: function () { return React.createElement(Clock, null); },
        title: 'Save Time at Checkout',
        description: function (checkoutAccessType) { return (React.createElement(Typography, null,
            "Runners and purchasers can check out with a",
            ' ',
            React.createElement(Tooltip, { placement: "bottom-start", title: "Your users can access the Pro Xtra ".concat(checkoutAccessType, " from the Home Depot App") },
                React.createElement(Typography, { component: "span", role: "button", decoration: "underline" },
                    "Pro Xtra ",
                    checkoutAccessType)),
            ' ',
            "at any register.")); },
    },
    {
        icon: function () { return React.createElement(Store, null); },
        title: 'Shop With Pro Xtra Benefits',
        description: function () { return (React.createElement(Typography, null,
            "All your",
            ' ',
            React.createElement(Link, { href: PROXTRA_PROGRAM_DETAILS }, "Pro Xtra account benefits"),
            ' ',
            "apply to Pro Allowance purchases.")); },
    },
];
export var SetUpProAllowance = function (_a) {
    var inactiveButtonStatus = _a.inactiveButtonStatus;
    var enableHdPass = !!useConfigService('ENABLE_HD_PASS_VERBIAGE');
    var checkoutAccessType = getCheckoutAccessTypeLabel(enableHdPass);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "sui-mb-6 2xl:sui-mb-8" },
            React.createElement("div", { className: "sui-pb-2" },
                React.createElement(Typography, { "data-testid": "pro-allowance-get-started-title", variant: "h2" }, "Set Spending Limits for Runners and Purchasers")),
            React.createElement("div", { className: "sui-pb-6" },
                React.createElement(Typography, null, "Assign funds to users on your account to make in-store purchases on your behalf. No credit card is needed when they check out in store.")),
            React.createElement("div", { className: "sui-flex sui-items-start sui-gap-1 sui-pb-8" },
                React.createElement("div", { className: "sui-pt-1" },
                    React.createElement(InfoFilled, { color: "info", size: "small" })),
                React.createElement(Typography, null, "You can't use Pro Allowance to purchase gift cards.")),
            React.createElement("div", { className: "sui-grid sui-grid-cols-12 sui-gap-8 lg:sui-grid-cols-9" },
                React.createElement("div", { className: "sui-col-span-12 md:sui-col-span-6 lg:sui-col-span-4 xl:sui-col-span-3" },
                    React.createElement(Button, { disabled: inactiveButtonStatus, fullWidth: true, href: MANAGE_ASSIGN_PRO_ALLOWANCE_PATH, "data-testid": "get-started-button", onClick: function () {
                            track(PRO_GET_STARTED);
                        } }, "Get Started With Pro Allowance")))),
        React.createElement("ul", { className: "sui-grid sui-grid-cols-9 sui-gap-8", "data-testid": "advantages" }, advantages.map(function (item) { return (React.createElement("li", { key: item.title, className: "sui-col-span-9 xl:sui-col-span-3" },
            React.createElement("div", { className: "sui-flex sui-items-center sui-gap-2 sui-mb-2" },
                item.icon(),
                React.createElement(Typography, { variant: "h4" }, item.title)),
            item.description(checkoutAccessType))); }))));
};
